/* eslint-disable */
import { injectGlobal } from 'easyguide'
import RationalDisplayMediumEot from './assets/fonts/RationalDisplay-Medium.eot'
import RationalDisplayMediumOtf from './assets/fonts/RationalDisplay-Medium.otf'
import RationalDisplayMediumWoff from './assets/fonts/RationalDisplay-Medium.woff'
import RationalDisplayMediumTtf from './assets/fonts/RationalDisplay-Medium.ttf'
import RationalDisplayMediumSvg from './assets/fonts/RationalDisplay-Medium.svg'
import RationalDisplayLightEot from './assets/fonts/RationalDisplay-Light.eot'
import RationalDisplayLightOtf from './assets/fonts/RationalDisplay-Light.otf'
import RationalDisplayLightWoff from './assets/fonts/RationalDisplay-Light.woff'
import RationalDisplayLightTtf from './assets/fonts/RationalDisplay-Light.ttf'
import RationalDisplayLightSvg from './assets/fonts/RationalDisplay-Light.svg'
import '@easynvest/greg-tokens/tokens.css'

injectGlobal`
  @font-face {
    font-family: 'Rational Display';
    src: url('${RationalDisplayMediumEot}?#iefix') format('embedded-opentype'),
      url('${RationalDisplayMediumOtf}')  format('opentype'),
      url('${RationalDisplayMediumWoff}') format('woff'),
      url('${RationalDisplayMediumTtf}')  format('truetype'),
      url('${RationalDisplayMediumSvg}') format('svg');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'Rational Display';
    src: url('${RationalDisplayLightEot}?#iefix') format('embedded-opentype'),
      url('${RationalDisplayLightOtf}')  format('opentype'),
      url('${RationalDisplayLightWoff}') format('woff'),
      url('${RationalDisplayLightTtf}')  format('truetype'),
      url('${RationalDisplayLightSvg}') format('svg');
    font-weight: 300;
    font-style: normal;
  }

  body * {
    font-family: 'Rational-Light';
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscal;
  }
  greg-alert *{
    font-family: 'Rational Display'
  }
`
